import { render, staticRenderFns } from "./PostDeclaredValue.vue?vue&type=template&id=91ea1ce2"
import script from "./PostDeclaredValue.vue?vue&type=script&lang=js"
export * from "./PostDeclaredValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports